import './App.css';
import Navbar from './components/NavBar';
import Routing from './components/Routing.js';

function App() {
  return (
    <>
      <Navbar />
      <Routing />
      {/* </Navbar> */}
    </>
  );
}

export default App;
